import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {GET_POST_NEW, GET_MASTER_INVENTORY} from "./type";

export const postSalesCorporateLeadNew = (data) => async (dispatch) => {

  let profileDetails = localStorage.getItem('profileDetails');
  let parsedProfileDetail = JSON.parse(profileDetails);
  let department_id = parsedProfileDetail[0].department_id;

  const updatedData = {
    ...data,
    department_id
  };
 
  // console.log('we are here ' , data); return false;
  const res = await callWebService(
    callTypes.post,
    updatedData,
    Config.postSalesNew.createPostNew
  );
  if (res?.data?.status === 0) {
    return true;
  }
  if (res?.data?.response?.status === true) {
    return true;
  }
  return false;
};

export const getSalesCorporateLeadNew = (commId) => async (dispatch) => {
 
  // console.log('we are here ' , data); return false;
  const res = await callWebService(
    callTypes.get,
    '',
    Config.postSalesNew.getPostNew+`/${commId}`
  );
  if (res?.data?.status === 0) {
    const payload = res.data.data ?? res.data.response?.data ?? null;
    dispatch({ type: GET_POST_NEW, payload });
    return payload;
  }
  if (res?.data?.response?.status === true) {
    dispatch({ type: GET_POST_NEW, payload: res.data.response.data });
    return res.data.response.data;
  }
  return null;
};

export const postSalesClientData = (data) => async (dispatch) => {
 
  // console.log('we are here ' , data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSalesNew.createClientDataForComm
  );
  if (res?.data?.status === 0) {
    return true;
  }
  if (res?.data?.response?.status === true) {
    return true;
  }
  return false;
};


export const postSolutionProduct = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSalesNew.createSolutionProduct
  );
  if (res?.data?.status === 0) {
    return true;
  }
  if (res?.data?.response?.status === true) {
    return true;
  }
  return false;
};

export const postSalesAdvancePayments = (data) => async (dispatch) => {
 
  // console.log('we are here ' , data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSalesNew.saveAdvancePayments
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};


export const postSalesInstallation = (data) => async (dispatch) => {
 
  // console.log('we are here ' , data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSalesNew.postSalesInstallation
  );
  if (res?.data?.status === 0) {
    return true;
  }
  if (res?.data?.response?.status === true) {
    return true;
  }
  return false;
};
  // console.log('we are here ' , data); return false;

  // postSalesInvoiceModule
  export const postSalesInvoiceModule = (data) => async (dispatch) => {
 
    // console.log('we are here ' , data); return false;
    const res = await callWebService(
      callTypes.post,
      data,
      Config.postSalesNew.postSalesInvoiceModule
    );
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  };

  // postSalesInvoiceModule
  export const postSalesMileStone = (data) => async (dispatch) => {
 
    // console.log('we are here ' , data); return false;
    const res = await callWebService(
      callTypes.post,
      data,
      Config.postSalesNew.postSalesMileStone
    );
    if (res?.data?.status === 0) {
      return true;
    }
    if (res?.data?.response?.status === true) {
      return true;
    }
    return false;
  };

  // postSalesInvoiceModule
  export const postCapexInvoiceModule = (data) => async (dispatch) => {
 
    const res = await callWebService(
      callTypes.post,
      data,
      Config.postSalesNew.postCapexInvoiceModule
    );
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  };

  // postSalesInvoiceModule
  export const contractInvoicePreview = (data) => async (dispatch) => {
 
    const res = await callWebService(
      callTypes.post,
      data,
      Config.postSalesNew.contractInvoicePreview
    );
    if (res) {
      const payload = res.data?.response?.data ?? res.data?.data;
      if (res.data?.status === 0 || res.data?.response?.status === true) {
        return payload;
      }
    }
    return '';
  };
  
   
  

export const postSalesApartmentLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    paymentTerms,
    paymentTermsDesc,
    products,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    // toTime,
    // fromTime,
    pickDate,
    gateDetails,
    scope_of_civil_work,
    categoryInventory,
    nonGstFile,
    paymentDueDays,
    installationData,
    tags,
    payment,
    increament,
    latePayCharge,
    clientData,
    solution_type,
    milestone,
    InvoiceModuleData,
    rel_docs,
    shipFileUpload,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: slotsNoFourWheeler,
    two_wheeler_slots: slotsNoTwoWheeler,
    expected_live_date: `${expectedLive}`,
    marketing_requirement: `${marketingReq}`,
    no_of_tags: `${TagsNoPost}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        /* start_time: `${fromTime}`,
        end_time: `${toTime}`, */
        other_rule: `${anyOther}`,
      },
    ],
    // gates: [...gateDetails],
    hardware: [...categoryInventory],
    commercial: [
      {
        commercial_type_id: commercialType,
        description: `${paymentTermsDesc}`,
        client_share: clientShare,
        company_share: companyShare,
        cost_per_slot: costPerSlot,
        no_of_mg_slots: MGSlots,
        take: takeEtaxes,
        take_percentage: takePerct,
        installation_amount: installationAmount,
        latePayCharge: `${latePayCharge}`,
        subscription_amount: subAmt,
        payment_terms_id: paymentTerms,
        product_id: products,
        payment_mode: `${paymentMode}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        rel_docs: `${rel_docs}`
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: billGeoStateId,
        geo_city_id: billGeoCityId,
        geo_pin_code: billPinId,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: shipGeoStateId,
        geo_city_id: shipGeoCityId,
        geo_pin_code: shipPinId,
      },
    ],
    installation: installationData,
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],

    client: clientData,
    milestone: milestone,
    InvoiceModuleData:InvoiceModuleData

  };
  if(leadStatus === 9){
    data.gates = [...gateDetails];
  }
      // console.log(data); return false;

  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostApartment
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};
export const postSalesSupplyLead = (val) => async (dispatch) => {
  const {
    leadId,
    LockIn,
    MGPerSlot,
    MGSlots,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    paymentTerms,
    revenueShare,
    revenueSlots,
    securityDeposit,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    gstFile,
    gstNumber,
    gstRegis,
    isSEZ,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    slotsRevenue4Car,
    slotsRevenue2Bike,
    parkCommission,
    categoryInventory,
    nonGstFile,
    agreementDocument,
    marketingSignageCount,
    marketingSignageType,
    approachVideo,
    slots2MgBike,
    slots4MgCar,
    shipFileUpload,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots_mg: `${slots2MgBike}`,
    two_wheeler_slots_mg: `${slots4MgCar}`,
    four_wheeler_slots_revenue: `${slotsRevenue4Car}`,
    two_wheeler_slots_revenue: `${slotsRevenue2Bike}`,
    cost_per_slot: `${costPerSlot}`,
    park_commision: `${parkCommission}`,
    agreement_document: agreementDocument,
    signage_requirements_number: `${marketingSignageCount}`,
    signage_requirements_type: `${marketingSignageType}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    approach_video: approachVideo,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        start_time: `${fromTime}`,
        end_time: `${toTime}`,
        other_rule: `${anyOther}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: '',
        client_share: `${clientShare}`,
        company_share: `${companyShare}`,
        cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        take: `${takeEtaxes}`,
        take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        payment_mode: `${paymentMode}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots !== '' ? revenueSlots : 0}`,
        revenue_share: `${revenueShare !== '' ? revenueShare : 0}`,
        mg_cost_per_slot: `${MGPerSlot}`,
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    gates: [...gateDetails],
    hardware: [...categoryInventory],
  };
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostSupply
  );
  if (res?.data?.status === true) {
    return true;
  }
  return false;
};

export const getInventoryMasterData = (lead_sub_type,gateIds) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.postSalesNew.getMasterInventory}?lead_sub_type=${lead_sub_type}&gate_ids=${gateIds}`
  );
  if (res?.data?.status === 0) {
    const payload = res.data.data ?? res.data.response?.data ?? [];
    dispatch({ type: GET_MASTER_INVENTORY, payload });
    return payload;
  }
  if (res?.data?.response?.data) {
    dispatch({ type: GET_MASTER_INVENTORY, payload: res.data.response.data });
    return res.data.response.data;
  }
  return null;
};
